<template lang="pug">
VSelect.select-language(
  :id="id"
  v-model="model"
  :items="i18n.locales.value"
  :label="i18n.t('Settings.Language')"
  :color="dark ? 'secondary' : 'secondary-c900'"
  variant="outlined"
  :hide-details="true"
  item-title="name"
  item-value="code"
)
</template>

<script setup lang="ts">
/**
 * Language switcher.
 * See https://v8.i18n.nuxtjs.org/guide/lang-switcher
 */
import type { Locale } from "vue-i18n";
import { useDarkMode } from "~/composables/useDarkMode";

const i18n = useI18n();
const dark = useDarkMode();

const model = computed<Locale>({
  get() {
    return i18n.locale.value;
  },
  set(val) {
    i18n.setLocale(val);
  },
});

const id = useId();
</script>
